export const topicService = {
    getInnerTopics
}

function getInnerTopics(topicId, topics){
    return topics
        .filter(s => s.id.toString().startsWith(topicId) 
            && s.id.toString().length === topicId.toString().length + 1)
}